import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import theme from './theme';
import { AuthProvider } from './contexts/AuthContext';
import App from './App';
import FeedbackViewPage from './pages/FeedbackViewPage';
import KioskPage from './pages/visitor/KioskPage';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Standalone public pages — render WITHOUT Chakra so overflow:hidden never applies.
// These deliberately bypass the router; they are self-contained pages.
const path = window.location.pathname;
if (path.startsWith('/feedback/')) {
  // Remove overflow:hidden that index.css sets on root
  document.documentElement.style.overflow = 'auto';
  document.body.style.overflow = 'auto';
  document.getElementById('root').style.overflow = 'auto';
  document.getElementById('root').style.height = 'auto';
  root.render(<FeedbackViewPage />);
} else if (path.startsWith('/visitor/')) {
  root.render(<KioskPage />);
} else {
  root.render(
    <BrowserRouter>
      <ChakraProvider theme={theme}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ChakraProvider>
    </BrowserRouter>
  );
}
